$(document).ready(function () {
  if (document.querySelector('.btn-filter')) {
    let modal = document.querySelector('.c-table-filters_filters');
    document.querySelector('.btn-filter').addEventListener('click', () => {
      modal.classList.add('d-block')
      modal.classList.add('open')
      document.body.classList.add('no-scroll')
      document.body.classList.add('filters')
    })
    document.querySelectorAll('.btn-close-modal').forEach(btn => {
      btn.addEventListener('click', () => {
        modal.classList.remove('open')
        document.body.classList.remove('no-scroll')
        document.body.classList.remove('filters')
        // setTimeout(() => {
        //     modal.style.display = "none";
        //   }, 350);
      })
    })
  }
  document.querySelector('.btn-menu-movil').addEventListener('click', () => {
    document.body.classList.toggle('no-scroll')
  })

  const $progress = document.querySelector(".c-steps");
  const $next = document.querySelector(".btn#next");
  const $prev = document.querySelector(".btn#prev");

});
window.addEventListener("resize", () => {
  if (window.matchMedia('(min-width: 992px)').matches) {
    if (document.querySelector('.btn-filter')) {
      if (document.querySelector('.c-table-filters_filters').classList.contains('open')) {
        document.querySelector('.c-table-filters_filters').classList.remove('open')
        document.body.classList.remove('no-scroll')
        document.body.classList.remove('filters')
      }
    }
  }
})

document.addEventListener('DOMContentLoaded', function () {
  // Inicializar tooltips en toda la página
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
});


//////////// PARTE PUBLIC ////////////////

let swiperCards = null;
let swiperCardsHover = null;
let swiperSteps = null;

function initSwiperCards() {
  if (window.innerWidth < 768 && swiperCards === null) {
    swiperCards = new Swiper(".c-swiper-cards", {
      spaceBetween: 16,
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
      },
    });
  } else if (window.innerWidth >= 768 && swiperCards !== null) {
    swiperCards.destroy(true, true);
    swiperCards = null;
  }
}

function initSwiperCardsHover() {
  if (window.innerWidth < 992 && swiperCardsHover === null) {
    swiperCardsHover = new Swiper(".c-swiper-card-hover", {
      spaceBetween: 16,
      slidesPerView: "auto",
      pagination: {
        el: ".swiper-pagination",
      },
    });
  } else if (window.innerWidth >= 992 && swiperCardsHover !== null) {
    swiperCardsHover.destroy(true, true);
    swiperCardsHover = null;
  }
}
function initSwiperSteps() {
  swiperSteps = new Swiper(".c-steps-swiper", {
    slidesPerView: "auto",
    spaceBetween: 32,
     navigation: {
        nextEl: ".c-steps-swiper_next",
        prevEl: ".c-steps-swiper_prev",
      },
  });


}
function adjustInfos() {
  const container = document.querySelector(".c-ciclo-npl");
  if (!container) return;

  const containerRect = container.getBoundingClientRect();
  const infos = container.querySelectorAll(".c-ciclo-npl_info");

  // solo aplicar si la pantalla es mayor a 768px
  if (window.innerWidth > 768) {
    infos.forEach(info => {
      const parent = info.closest(".c-ciclo-npl_item");
      if (parent) {
        const parentRect = parent.getBoundingClientRect();

        // coordenadas relativas al container
        const offsetLeft = parentRect.left - containerRect.left;
        const offsetRight = containerRect.right - parentRect.right;

        // centro del contenedor
        const containerMid = containerRect.width / 2;
        const parentCenter = offsetLeft + parentRect.width / 2;

        if (parentCenter < containerMid) {
          // ITEM EN LA IZQUIERDA → abre hacia la derecha
          info.style.width = containerRect.width - offsetLeft + "px";
        } else {
          // ITEM EN LA DERECHA → abre hacia la izquierda
          info.style.width = parentRect.right - containerRect.left + "px";
          info.classList.add('title-left')
        }
      }
    });
  } else {
    // resetear estilos en mobile
    infos.forEach(info => {
      info.style.width = "";
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  $('.select2').select2({
    placeholder: 'Selecciona una o varias opciones',
    width: '100%',
    closeOnSelect: false
  });

  // marca cada select2 vacío con clase para controlar CSS
  function updateEmptyClass($sel) {
    var $cont = $sel.next('.select2-container');
    if (!$cont.length) return;
    var val = $sel.val();
    if (!val || val.length === 0) {
      $cont.find('.select2-selection--multiple').addClass('select2--empty');
    } else {
      $cont.find('.select2-selection--multiple').removeClass('select2--empty');
    }
  }

  // init all
  $('.select2').each(function() {
    updateEmptyClass($(this));
  });

  // actualizar al seleccionar / deseleccionar
  $('.select2').on('select2:select select2:unselect change', function() {
    updateEmptyClass($(this));
  });

  // si quieres forzar que al abrir se vea el placeholder correctamente
  $('.select2').on('select2:opening', function() {
    updateEmptyClass($(this));
  });
});

// Ejecutar al cargar y al resize
function ajustesLayout() {
  // posicionarInfos();
  if(document.querySelector('.c-swiper-cards')) {
    initSwiperCards();
  }
  if(document.querySelector('.c-swiper-card-hover')) {
    initSwiperCardsHover();
  }
  if(document.querySelector('.c-steps-swiper')) {
    initSwiperSteps();
  }
  if(document.querySelector('.c-ciclo-npl')) {
  adjustInfos();

  }
}

// primera carga
window.addEventListener('load', ajustesLayout);

// cambios de tamaño
window.addEventListener('resize', ajustesLayout);
